export default "__VITE_ASSET__3b830c83__"